<template>
  <div class="legal-container">
    <h1>Ajuda e Suporte – Zinnes</h1>
    <p><strong>Última Atualização: 17/05/2025</strong></p>

    <h2>1. Introdução</h2>
    <p>Bem-vindo à página de Ajuda e Suporte da Zinnes, sua plataforma de leitura e publicação de quadrinhos, disponível
      em <a href="https://www.zinnes.com.br">www.zinnes.com.br</a>. Estamos aqui para ajudar você a aproveitar ao máximo
      nossa
      plataforma, seja você um criador, leitor ou usuário geral. Esta página oferece orientações, respostas a perguntas
      frequentes e informações sobre como entrar em contato conosco. Se precisar de mais ajuda, envie-nos um e-mail para
      <a href="mailto:suporte.zinnes@gmail.com">suporte.zinnes@gmail.com</a>.
    </p>

    <h2>2. Primeiros Passos</h2>
    <p>Se você é novo na Zinnes, aqui estão algumas dicas para começar:</p>
    <ul>
      <li><strong>Criar uma Conta:</strong> Acesse a página de cadastro em <a
          href="https://www.zinnes.com.br/cadastro">https://www.zinnes.com.br/cadastro</a>, forneça seu nome, nickname,
        e-mail e senha, e siga
        as instruções para verificar sua conta.</li>
      <li><strong>Navegar na Plataforma:</strong> Use a barra de navegação para explorar quadrinhos, buscar por gêneros
        ou acessar seu perfil.</li>
      <li><strong>Configurar o Perfil:</strong> Adicione uma foto de perfil e uma biografia para personalizar sua
        experiência.</li>
      <li><strong>Gerenciar Notificações:</strong> Ajuste suas preferências de e-mail no painel de configurações para
        receber atualizações sobre novos quadrinhos ou mensagens.</li>
    </ul>

    <h2>3. Para Criadores</h2>
    <p>Se você é um autor ou artista, a Zinnes oferece ferramentas para publicar e monetizar seus quadrinhos:</p>
    <ul>
      <li><strong>Publicar Quadrinhos:</strong> Acesse o painel de criadores em <a
          href="https://www.zinnes.com.br/dashboard/publicar-obra">https://www.zinnes.com.br/dashboard/publicar-obra</a>,
        faça upload de seus arquivos (formatos
        suportados: PNG, JPEG) e configure título, descrição e tags etc...</li>
      <li><strong>Direitos Autorais:</strong> Você mantém os direitos sobre seu conteúdo, mas concede à Zinnes uma
        licença para exibi-lo, conforme descrito nos <a href="https://www.zinnes.com/termos-de-uso">Termos de Uso</a>.
      </li>
      <li><strong>Moderação de Conteúdo:</strong> Certifique-se de que seu conteúdo segue nossas diretrizes, evitando
        material ofensivo, ilegal ou que viole direitos de terceiros.</li>
    </ul>

    <h2>4. Para Leitores</h2>
    <p>Se você ama quadrinhos, a Zinnes é o lugar para descobrir novas histórias:</p>
    <ul>
      <li><strong>Encontrar Quadrinhos:</strong> Use a barra de pesquisa ou filtros por gênero, popularidade ou autor
        para encontrar conteúdo.</li>

      <li><strong>Interagir:</strong> Deixe comentários, avaliações ou compartilhe quadrinhos nas redes sociais (quando
        disponível).</li>
      <li><strong>Problemas de Acesso:</strong> Se não conseguir acessar um quadrinho, verifique sua conexão ou limpe o
        cache do navegador.</li>
    </ul>

    <h2>5. Perguntas Frequentes (FAQ)</h2>
    <p>Aqui estão algumas respostas para perguntas comuns:</p>
    <ul>
      <li><strong>Não consigo fazer login. O que faço?</strong> Verifique se seu e-mail e senha estão corretos. Use a
        opção “Esqueci minha senha” para redefinir sua senha. Se o problema persistir, entre em contato com o suporte.
      </li>
      <li><strong>Por que meu quadrinho foi removido?</strong> Seu conteúdo pode ter violado nossas diretrizes (ex.:
        conteúdo ofensivo ou protegido por direitos autorais). Você receberá uma notificação com detalhes. Para
        recorrer, contate o suporte.</li>
      <li><strong>Como excluir minha conta?</strong> Acesse as configurações do perfil e selecione “Excluir Conta”.
        Consulte a <a href="https://www.zinnes.com/politica-de-privacidade">Política de Privacidade</a> para mais
        detalhes sobre
        exclusão de dados.</li>
      <li><strong>Posso usar a Zinnes se for menor de 13 anos?</strong> A plataforma não é destinada a menores de 13
        anos sem supervisão de um responsável legal. Veja mais em nossa <a
          href="https://www.zinnes.com/politica-de-privacidade">Política de Privacidade</a>.</li>
    </ul>

    <h2>6. Entre em Contato</h2>
    <p>Se precisar de ajuda adicional, entre em contato com nossa equipe:</p>
    <ul>
      <li><strong>E-mail:</strong> <a href="mailto:suporte.zinnes@gmail.com">suporte.zinnes@gmail.com</a> (resposta em
        até
        48 horas úteis).</li>
      <li><strong>Redes Sociais:</strong> Siga-nos no <a href="https://www.instagram.com/zinnesoficial/"> instagram
          (@zinnes)</a> para atualizações e
        suporte rápido.</li>
    </ul>
    <p>Nosso horário de atendimento é de segunda a sexta, das 9h às 17h (horário de Brasília). Responderemos o mais
      rápido possível!</p>

    <h2>7. Sobre Nós</h2>
    <p>A Zinnes é uma plataforma apaixonada por quadrinhos, criada para conectar autores e leitores em um ambiente
      criativo e inovador. Nossa equipe é composta por:</p>
    <ul>
      <li><strong>Andy Ichigo:</strong> Artista de mangá e quadrinhos de São Paulo, SP, reconhecido pela one-shot “My
        World”, vencedora do 5º Concurso Mangás do Estúdio Armon. Trabalhou com editoras underground e independentes,
        como Aquele Velho Mar, Syncro e Amor Sismico.</li>
      <li><strong>Felipe Lee:</strong> Diretor e sócio fundador da Zinnes, com quase 10 anos de experiência em
        gerenciamento de projetos, storyboard e edição de filmes. Apaixonado por quadrinhos, também é autor e animador
        nas horas vagas.</li>
      <li><strong>Fernando:</strong> Quadrinista há 15 anos, criou obras como TDF, A Experiência, Syncro I e Potric.
        Apaixonado por criar mundos e personagens que emocionam e inspiram os leitores.</li>
      <li><strong>Guilherme:</strong> Escritor, roteirista e diretor da Zinnes, cuida das relações públicas e participa
        da construção de projetos. Autor de Karma, Agatha e o Reino Sombrio, Rei do Norte e Tribos.</li>
    </ul>

    <h2>8. Políticas Relacionadas</h2>
    <p>Para mais informações sobre como usamos seus dados e suas responsabilidades na plataforma, consulte:</p>
    <ul>
      <li><a href="https://www.zinnes.com/politica-de-privacidade">Política de Privacidade</a></li>
      <li><a href="https://www.zinnes.com/termos-de-uso">Termos de Uso</a></li>
    </ul>

    <div class="footer">
      <p>Zinnes – Sua plataforma de quadrinhos!</p>
      <p><strong>CNPJ:</strong> 52.230.302/0001-50</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpSupport',
}
</script>

<style scoped>
.legal-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem 2rem;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

h1 {
  color: #631b8d;
  text-align: center;
  margin-bottom: 1.5rem;
}

h2 {
  color: #631b8d;
  margin-top: 2rem;
}

p,
li {
  margin-bottom: 1rem;
}

ul {
  list-style-type: disc;
  margin-left: 2rem;
}

a {
  color: #631b8d;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.footer {
  text-align: center;
  margin-top: 2rem;
  font-size: 0.9rem;
  color: #666;
}

@media (max-width: 600px) {
  .legal-container {
    padding: 1rem;
  }
}
</style>
